import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

export const InlineBox = props => {
  const {
    children,
    className
  } = props;

  return (
    <div className={clsx('flex border-box w-full items-center overflow-hidden', className)} style={{ flexGrow: 0, flexShrink: 0 }}>
      {children}
    </div>
  );
};

InlineBox.propTypes = {
  className: PropTypes.string
};

export default InlineBox;
